import React from 'react';
import { Formalite } from '@europrocurement/l2d-domain/reducers/formalites/slices/formalite';
import { Box, Card } from '@mui/material';
import { useSelector } from 'react-redux';
import { DossierValidator, dossierValidatorsSelector } from '@europrocurement/l2d-domain';
import NoResultPreview from '../../components/NoResultPreview';
import TableRowActions from '../../components/TableRowActions';
import StaticDatatable from '../../components/StaticDatable';

type FormalityValidatorsCardProps = {
    formality: Formalite;
    onUpdateValidators: (selectedItems: (string | number)[]) => void;
};

const FormalityValidatorsCard: React.FunctionComponent<FormalityValidatorsCardProps> = function (
    props,
) {
    const { formality, onUpdateValidators } = props;
    const availableValidators = useSelector(dossierValidatorsSelector).data;
    const formalityValidators = formality.validators ? formality.validators : [];
    const rows = availableValidators
        .filter(
            (item: DossierValidator) =>
                item.id && formalityValidators.indexOf(item.id as unknown as string) !== -1,
        )
        .sort((a: DossierValidator, b: DossierValidator) => {
            const aLabel = a.label as unknown as string;
            const bLabel = b.label as unknown as string;

            if (aLabel.toLowerCase() < bLabel.toLowerCase()) {
                return -1;
            }

            if (aLabel.toLowerCase() > bLabel.toLowerCase()) {
                return 1;
            }

            return 0;
        });

    const onRemoveItem = (validator: DossierValidator) => {
        const statuses = formalityValidators.filter(
            (item: string | number) => item !== validator.id,
        );
        onUpdateValidators(statuses);
    };

    if (!rows.length) {
        return (
            <Card>
                <NoResultPreview message="Aucun valideur n'est associé à cette formalité" />
            </Card>
        );
    }

    const celStyle = {
        display: 'flex',
        alignItems: 'center',
        minHeight: '40px',
    };
    const columns = [
        {
            label: 'Nom',
            field: 'label',
            isDisplayed: true,
            render: (item: DossierValidator) => <Box style={celStyle}>{item.label}</Box>,
        },
        {
            label: 'Actions',
            displayLabel: false,
            isDisplayed: true,
            render: (item: DossierValidator) => (
                <TableRowActions
                    itemId={item.id as unknown as string}
                    removeItem={() => {
                        onRemoveItem(item);
                    }}
                />
            ),
        },
    ];

    return (
        <Card>
            <StaticDatatable
                data={rows}
                columns={columns}
                totalItemsCount={formality?.validators?.length || 0}
            />
        </Card>
    );
};

export default FormalityValidatorsCard;
